export const language: any = {
  main: "Main",
  ingredients: "Ingredients",
  ai_chef: "AI chef",
  favorites: "Favorites",
  menu: "Menu",
  get_start: "Get Started",
  title_first_1: "AI suggests recipes by age",
  title_second_1: "Perfectly organized from menu to recipe",
  content_1: "Stop worrying about daily menus and calories. From now on, get suggestions from Hey! Cooker",
  title_first_2: "It's chilly today, you've had a hard day.",
  title_second_2: "How about having some army stew after work?",
  content_2: "Find the canned meat and instant noodles left in your fridge and make a simple dinner!",
  my_food_ingredients: "Don't know what to cook?",
  btn_add_photo: "Choose an image or take a photo",
  my_food_reason: "Select the ingredients you have",
  btn_get_cooking: "Get AI Recipe Suggestions",
  enriching_title: "Enrich your body and mind",
  enriching: "A collection of recipes",
  photo_registration_title: "Take a photo or receipt<br/>and get menu recommendations!",
  photo_registration_content: `Add the joy of cooking by identifying ingredients<br/> and analyzing recipes with AI!`,
  food_suggestions_title: "Worried about what to eat?",
  food_suggestions_sub_title: "Themed Dishes",
  our_interests_title: "Create the perfect menu for you and your family!",
  our_interests_sub_title: "Choose based on age and gender.",
  favorite_title: "A variety of cooking notebooks",
  weather_title: "Dishes perfect for chilly weather",
  video_title: "Check out the vibrant videos",
  tag: {
    close: "Close",
    open: "Expand"
  },
  no_data: "No data",
  update_version_submit: "Update right away",
  update_version_title: "We have the latest version of the app.",
  update_version_content: "For optimal usage experience, please update to the latest version of the app",
  close_btn: "Close",
  not_video_id: "Video does not exist",
  favorite_login: "Log in or sign up to save your favorite recipe list.",
  favorite_section_title: "Don't forget to review your saved recipes",
  favorite_section_description: "My favorite recipes",
  discover:"Discover",
  my_cooker:"My Kitchen",
  view_recipe: "View recipes from selected ingredients",
  my_ingredient: "My ingredients",
  add_ingredient: "Add my ingredients",
  video_section_title: "Explore and feel through videos",
  video_section_description: "Recommended cooking videos",
  age_10: "U10",
  age_10_to_20: "10-20 years",
  age_20_to_30: "20-30 years",
  age_30_to_40: "30-40 years",
  age_40_to_50: "40-50 years",
  age_more_50: "50+",
  suggest_section_title: "Hey! Cooker will help you choose",
  suggest_section_description: "What topics are you interested in?",
  weather_title1: "Today's suggestions",
  weather_title2: "What to eat on a rainy, chilly day?",
  tasteSuggestion1: "Satisfy your taste buds",
  tasteSuggestion2: "Flavors made just for you",
  tasteTitle1: "Spicy <br />and tempting",
  tasteTitle2: "Fresh and <br />light",
  tasteTitle3: "Tangy <br />and exciting",
  tasteTitle4: "Fragrant - <br />sweet",
  tasteTitle5: "Blended and <br />captivating",
  tasteDescription1: "#stir-fry #grill #rainy day",
  tasteDescription2: "#fresh #fiber #diet",
  tasteDescription3: "#sour #sweet #exciting",
  tasteDescription4: "#unique #seeds #magic",
  tasteDescription5: "#taste #nutrition #feeling",
  suggest_item_title1: "Simple Dishes",
  suggest_item_description1: `Simple breakfast and lunch recipes`,
  suggest_item_title2: "Diet",
  suggest_item_description2: `Low-carb<br/>Absolutely delicious`,
  suggest_item_title3: "Year-end Food",
  suggest_item_description3: `Home party dishes`,
  suggest_item_title4: "Healthy Food",
  suggest_item_description4: `For a healthy body and mind<br/>Make better choices`,
  suggest_item_title5: "Simple Snacks",
  suggest_item_description5: `Snacks for solo drinking`,
  history: "Image analysis history",
  community: {
    sub_title: "Cook with everyone",
    title: "Hey! Cooker community search",
    trending: "Trend",
    follow: "Followed",
    video: "Video",
    discover :"Discover",
    no_data: "No new updates from the Hey! Cooker community",
    discover_post: "Searching more posts in the community",
  },
  user_suggest_title1: "Today's suggestions",
  user_suggest_title2: "Random Recipe Suggestions",
}
